var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 56,
    viewBox: "0 0 48 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40.962 20.348L26.31 28.742L25.764 36.716L40.584 28.16V37.826L23.754 47.564L6.91796 37.826V18.356L24.042 8.62403L32.676 13.532L17.646 22.13L24.69 25.94L39.6 17.468L46.368 13.622L39.528 9.69203L24.198 0.926025L0.485962 14.51V41.678L24 55.262L47.514 41.678V24.326V16.502L40.962 20.348Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.828 25.244V33.038L22.464 36.584V29.228L15.828 25.244Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.16939eba1e52aee46515b3a9ed0d26e5.svg";
export { ForwardRef as ReactComponent };